(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-documentation"]) return;
  try {
    
  class DocumentationTabs extends HTMLElement {
    constructor() {
      super();
      this.mainNav = this.querySelector('#main-nav');
      this.init();
    }

    init() {
      const navItems = this.querySelectorAll('.documentation-nav-item');
      const contentItems = this.querySelectorAll('.documentation-page-content');
      
      // Pre-generate IDs for ALL headings in ALL pages before doing anything else
      contentItems.forEach((contentItem, index) => {
        const headings = contentItem.querySelectorAll('h1, h2, h3, h4, h5, h6');
        headings.forEach((heading, headingIndex) => {
          if (!heading.id) {
            const id = `heading-${headingIndex}-${heading.textContent.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`;
            heading.id = id;
          }
        });
      });
      
      // Mark all content items as JS loaded
      contentItems.forEach(item => item.classList.add('js-loaded'));

      navItems.forEach((item, index) => {
        item.addEventListener('click', (e) => {
          e.preventDefault();
          
          const isAlreadyActive = item.classList.contains('active');
          
          // If clicking on already active tab, toggle outline (accordion behavior)
          if (isAlreadyActive) {
            const existingOutline = item.nextElementSibling;
            if (existingOutline && existingOutline.classList.contains('documentation-outline')) {
              existingOutline.classList.toggle('collapsed');
            }
            return;
          }
          
          // Remove active class from all items
          navItems.forEach(nav => nav.classList.remove('active'));
          contentItems.forEach(content => content.classList.remove('active'));
          
          // Add active class to clicked item
          item.classList.add('active');
          
          // Show corresponding content
          const targetId = item.getAttribute('data-target');
          const targetContent = this.querySelector(`#${targetId}`);
          if (targetContent) {
            targetContent.classList.add('active');
            // Generate outline for this page
            this.generateOutline(targetContent, item);
          }
        });

        // Set first item as active only if no hash
        if (index === 0 && !window.location.hash) {
          item.classList.add('active');
        }
      });

      // Handle hash navigation first - before generating default outline
      if (window.location.hash) {
        this.handleHashNavigation(window.location.hash);
      } else {
        // Only generate outline for first page if no hash
        const firstContent = contentItems[0];
        const firstNav = navItems[0];
        if (firstContent && firstNav) {
          firstContent.classList.add('active');
          firstNav.classList.add('active');
          this.generateOutline(firstContent, firstNav);
        }
      }

      // Setup scroll spy for outline
      this.setupScrollSpy();
    }

    handleHashNavigation(hash) {
      const hashValue = hash.substring(1);
      
      // First, try to find if it's a page hash (doc-page-...)
      const targetNav = this.querySelector(`[data-target="${hashValue}"]`);
      if (targetNav) {
        targetNav.click();
        return;
      }
      
      // If not a page hash, search for the heading across all pages
      const allContentItems = this.querySelectorAll('.documentation-page-content');
      let foundPage = null;
      let foundHeading = null;
      
      for (const contentItem of allContentItems) {
        const heading = contentItem.querySelector(`#${hashValue}`);
        if (heading) {
          foundPage = contentItem;
          foundHeading = heading;
          break;
        }
      }
      
      if (foundPage && foundHeading) {
        // Find the nav item for this page
        const pageId = foundPage.id;
        const pageNav = this.querySelector(`[data-target="${pageId}"]`);
        
        if (pageNav) {
          // Remove active from all
          const navItems = this.querySelectorAll('.documentation-nav-item');
          const contentItems = this.querySelectorAll('.documentation-page-content');
          navItems.forEach(nav => nav.classList.remove('active'));
          contentItems.forEach(content => content.classList.remove('active'));
          
          // Activate the correct page
          pageNav.classList.add('active');
          foundPage.classList.add('active');
          
          // Generate outline for this page
          this.generateOutline(foundPage, pageNav);
          
          // Wait for outline to be generated, then scroll to heading
          setTimeout(() => {
            foundHeading.scrollIntoView({ behavior: 'smooth', block: 'start' });
            
            // Update the active outline item
            const outlineLink = this.mainNav.querySelector(`.outline-item[href="#${hashValue}"]`);
            if (outlineLink) {
              this.updateOutlineActive(outlineLink);
            }
          }, 100);
        }
      }
    }

    generateOutline(content, navItem) {
      if (!this.mainNav) return;

      // Remove any existing outline
      const existingOutline = this.mainNav.querySelector('.documentation-outline');
      if (existingOutline) {
        existingOutline.remove();
      }

      // Get all headings from the content
      const headings = content.querySelectorAll('h1, h2, h3, h4, h5, h6');
      
      if (headings.length === 0) {
        return;
      }

      // Create outline container
      const outlineContainer = document.createElement('div');
      outlineContainer.className = 'documentation-outline';

      headings.forEach((heading) => {
        // ID should already exist from init, but double-check
        if (!heading.id) {
          console.warn('Heading missing ID:', heading.textContent);
        }

        // Create outline item
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.className = `outline-item outline-item-${heading.tagName.toLowerCase()}`;
        link.textContent = heading.textContent;
        
        link.addEventListener('click', (e) => {
          e.preventDefault();
          heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
          
          // Update URL hash without jumping
          history.pushState(null, null, `#${heading.id}`);
          
          // Update active state
          this.updateOutlineActive(link);
        });

        outlineContainer.appendChild(link);
      });

      // Insert outline after the active nav item
      navItem.parentNode.insertBefore(outlineContainer, navItem.nextSibling);
    }

    setupScrollSpy() {
      let ticking = false;

      const handleScroll = () => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            this.updateActiveHeading();
            ticking = false;
          });
          ticking = true;
        }
      };

      window.addEventListener('scroll', handleScroll);
    }

    updateActiveHeading() {
      const outline = this.mainNav.querySelector('.documentation-outline');
      if (!outline || outline.classList.contains('collapsed')) return;

      const outlineLinks = outline.querySelectorAll('.outline-item');
      const activeContent = this.querySelector('.documentation-page-content.active');
      
      if (!activeContent) return;

      const headings = activeContent.querySelectorAll('h1, h2, h3, h4, h5, h6');
      let currentHeading = null;

      // Find the heading closest to the top of the viewport
      headings.forEach(heading => {
        const rect = heading.getBoundingClientRect();
        if (rect.top <= 100) {
          currentHeading = heading;
        }
      });

      if (currentHeading) {
        outlineLinks.forEach(link => {
          const linkHref = link.getAttribute('href').substring(1);
          if (linkHref === currentHeading.id) {
            link.classList.add('active');
          } else {
            link.classList.remove('active');
          }
        });
      }
    }

    updateOutlineActive(activeLink) {
      const outline = this.mainNav.querySelector('.documentation-outline');
      if (!outline) return;

      const outlineLinks = outline.querySelectorAll('.outline-item');
      outlineLinks.forEach(link => link.classList.remove('active'));
      activeLink.classList.add('active');
    }
  }

  if (!customElements.get('documentation-tabs')) {
    customElements.define('documentation-tabs', DocumentationTabs);
  }

  } catch(e) { console.error(e); }
})();
})();
